import { render, staticRenderFns } from "./ContextMenuDuam.vue?vue&type=template&id=37b1ffad&scoped=true&"
import script from "./ContextMenuDuam.vue?vue&type=script&lang=js&"
export * from "./ContextMenuDuam.vue?vue&type=script&lang=js&"
import style0 from "./ContextMenuDuam.vue?vue&type=style&index=0&id=37b1ffad&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37b1ffad",
  null
  
)

export default component.exports